import { render } from "./ProductsIndex.vue?vue&type=template&id=1fb6dc13"
import script from "./ProductsIndex.vue?vue&type=script&lang=js"
export * from "./ProductsIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__